<script>
import { BAspect } from "bootstrap-vue";

export default {
  extends: BAspect
};
</script>